import { render, staticRenderFns } from "./BitacoraHistory.vue?vue&type=template&id=0f55d81a&scoped=true"
import script from "./BitacoraHistory.vue?vue&type=script&lang=js"
export * from "./BitacoraHistory.vue?vue&type=script&lang=js"
import style0 from "./BitacoraHistory.vue?vue&type=style&index=0&id=0f55d81a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f55d81a",
  null
  
)

export default component.exports